export default __webpack_public_path__ + "static/media/congo_stroke.05b7053f.svg";